import {DynamicGraphFilters} from '@modules/graph-inclusive/core/model/dynamic-graph-filters';
import moment from 'moment';

export const AttendanceFilters: DynamicGraphFilters = {
    always: [{
        label: 'startDate',
        value: moment().add(-2, 'weeks').startOf('day').toDate(),
        custom: {
            rules: ['required']
        }
    }, {
        label: 'endDate',
        value: moment().endOf('day').toDate(),
        custom: {
            rules: ['required']
        }
    }, {
        label: 'group',
        value: null
    }, {
        label: 'workgroup',
        value: null
    }],
    hidden: []
};
